import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

const w348 = css`
  width: 34.8rem;
`;

export const h190 = css`
  height: 19rem;
`;

export const h205 = css`
  height: 20.5rem;
`;

export const maxH440 = css`
  max-height: 44rem;
`;

export const overflowWrapAnywhere = css`
  overflow-wrap: anywhere;
`;

export const learnerWidgetStyles = cn('border border-border p-24 pb-28 rounded', w348);

export const tabMobileStylesClassName = css`
  .MuiTab-root:first-child {
    margin-inline-start: 2.4rem;
  }
  .MuiTab-root:last-child {
    margin-inline-end: 2.4rem;
  }
  .MuiTabs-flexContainer {
    width: max-content;
  }
`;
